import { useEffect } from 'react';
import DefaultNavbar from 'components/DefaultNavbar';
import DefaultFooter from 'components/DefaultFooter';
import Header from 'components/desk/Header';
import WorkingSection from 'components/desk/WorkingSection';
import TeamSection from 'components/desk/TeamSection';
import ComentsSection from 'components/desk/ComentsSection';
import Legend from 'components/desk/Legend';

export default function Desk() {
    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])
    return (
        <>
            <DefaultNavbar />
            <main>
                <Header/>
                <WorkingSection />
                <Legend />
                <TeamSection />
                <ComentsSection />
            </main>
            <DefaultFooter />
        </>
    );
}
